/**
 * Storefront blog addresses, shared by the server (SPA paths, crawler HTML) and the client.
 * /blog and /blog/<key> follow the browser language; /ru|en|he/blog… name it.
 */

/** Shop templates that draw the blog inside their own header and footer. */
export const BLOG_STOREFRONT_TEMPLATES = ['mizranit_v1'];

export const BLOG_PATH_RE = /^(?:\/(ru|en|he))?\/blog(?:\/([0-9a-z][0-9a-z_-]*))?\/?$/i;

/**
 * @param {unknown} templateId
 * @returns {boolean}
 */
export function storefrontTemplateHasBlog(templateId) {
  return BLOG_STOREFRONT_TEMPLATES.includes(String(templateId || ''));
}

/**
 * @param {string} pathname
 * @returns {{ lang: 'ru'|'en'|'he'|null, key: string|null } | null}
 */
export function parseBlogPath(pathname) {
  const match = BLOG_PATH_RE.exec(String(pathname || '').split('?')[0]);
  if (!match) return null;
  return {
    lang: match[1] ? /** @type {'ru'|'en'|'he'} */ (match[1].toLowerCase()) : null,
    key: match[2] ? match[2].toLowerCase() : null,
  };
}

/**
 * @param {string|null} lang
 * @param {string|null} [key]
 */
export function blogPath(lang, key = null) {
  const base = lang ? `/${lang}/blog` : '/blog';
  return key ? `${base}/${key}` : base;
}
